
import Coin1 from "../../../assets/outline/Coin1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Coin1Icon({ className, dataTestid = "Coin1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Coin1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
